import React from "react";
import { Answers, Protocol, Step } from "../../types";
import { SingleSelectStep } from "../SingleSelectStep";

export function ProtocolStep({
	protocols,
	onSelect,
	answers,
}: {
	protocols: Protocol[];
	onSelect: (value: string) => void;
	answers: Answers;
}) {
	return (
		<SingleSelectStep
			layout="list"
			options={protocols
				.filter((p) => p.category === answers.category)
				.map((p) => ({
					id: String(p.id),
					label: p.displayName,
					isSelected: String(answers.protocol) === String(p.id),
				}))}
			onSelect={onSelect}
		/>
	);
}
